/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { alpha } from '@mui/material/styles';

import { getCommandIntelligenceTokens } from '../../theme/commandIntelligenceTokens';

/**
 * @param {import('@mui/material').Theme & { validateMode?: Function }} theme
 * @param {boolean} isMobile
 */
export const getCommandIntelligenceAccessDeniedStyles = (theme, isMobile) => {
  const tokens = getCommandIntelligenceTokens(theme);

  return {
    root: {
      minHeight: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      py: isMobile ? 2 : 3,
      px: isMobile ? 1 : 2,
    },
    content: {
      width: '100%',
      maxWidth: '28rem',
      mx: 'auto',
      textAlign: 'center',
    },
    iconWrap: {
      display: 'flex',
      justifyContent: 'center',
      mb: isMobile ? 1.5 : 2,
    },
    icon: {
      fontSize: isMobile ? '2.5rem' : '3rem',
      color: alpha(tokens.accentIntelligence, 0.55),
    },
    title: {
      fontWeight: 600,
      fontSize: isMobile ? '1.1rem' : '1.25rem',
      lineHeight: 1.25,
      color: tokens.textPrimary,
      mb: 1,
    },
    message: {
      color: tokens.textSecondary,
      fontSize: isMobile ? '0.8125rem' : '0.875rem',
      lineHeight: 1.55,
    },
  };
};
